import { ApiError } from './api-client';

// Fire-and-forget wrapper for the "push local mutation to server" pattern.
// Swallows 401 silently (pre-auth mutations are normal — the user hasn't
// signed up yet, so the server can't accept them). Other errors are logged
// so dev catches them without breaking the UI.
export function syncFireAndForget(call: () => Promise<unknown>) {
  call().catch((err: unknown) => {
    if (err instanceof ApiError && err.status === 401) return;
    console.warn('[sync] background sync failed', err);
  });
}
